<script setup>
import EmptyState from './EmptyState.vue'
import IconBase from '../icon/IconBase.vue'
import IconPermissionLocked from '../icon/IconPermissionLocked.vue'

defineProps({
	title: {
		type: String,
		default: "You don't have permission to access this.",
	},
	ownerEmail: {
		type: String,
		default: '',
	},
	minHeight: {
		type: String,
		default: '55vh',
	},
})
</script>

<template>
	<EmptyState :min-height="minHeight" :title="title">
		<template #illustration>
			<IconBase
				:width="86"
				:height="80"
				:width-view-box="86"
				:height-view-box="80"
				fill="none"
				icon-name="No access"
			>
				<IconPermissionLocked />
			</IconBase>
		</template>
		<template #subtitle>
			<template v-if="ownerEmail">
				Contact
				<a class="text-surface-8 underline" :href="'mailto:' + ownerEmail">{{ ownerEmail }}</a>
				to gain access
			</template>
			<template v-else>
				Contact the team owner to gain access
			</template>
		</template>
	</EmptyState>
</template>
